'use client';

import { useMemo } from 'react';
import { useDraggable } from '@dnd-kit/core';

interface UseDraggableItemProps {
  itemId: number;
  isNonEstate: boolean;
}

export function useDraggableItem({
  itemId,
  isNonEstate
}: UseDraggableItemProps) {
  const data = useMemo(
    () => ({ type: 'inventory-item' as const, itemId, isNonEstate }),
    [itemId, isNonEstate]
  );

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: `inventory-item-${itemId}`,
      data
    });

  return {
    dragRef: setNodeRef,
    isDragging,
    attributes,
    listeners,
    transform
  };
}
